//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import TagPeopleGroup from "../../components/tag/Group";
import { mapGetters } from "vuex";
import { VALIDATE_INFO } from "../../store/mutation-types";
export default {
  name: "ValidateTagPeoplePage",
  components: { HiHeader, TagPeopleGroup },
  data() {
    return {
      swiperOption: {},
    };
  },
  computed: {
    ...mapGetters({
      form: VALIDATE_INFO,
    }),
    people() {
      return this.$route.query.type === "people";
    },
    title() {
      if (this.people) {
        return "Tag People";
      } else {
        return "Tag Product";
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/validate/TagPeople.vue